import React, { Component } from 'react';
import BackendClient from './BackendClient';
import Rooms from './Rooms';
import Room from './Room';
import Header from './Header'
import Login from './Login';
import Spectate from './Spectate';
import UserSetup from './UserSetup';
import ChangeNameDialog from './ChangeNameDialog';
import { Button, CircularProgress } from 'react-md';
import ErrorDialog from './ErrorDialog';
import {BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom'

const pubSub = require('./util/pubsub');

const STATUS_AUTH_LOGGEDOUT = 1;
const STATUS_AUTH_LOGGEDIN = 2;

const STATUS_USER_NULL = 1;
const STATUS_USER_IDLE = 2;
const STATUS_USER_PLAYING = 3;

class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
            status_auth: undefined,
            status_user: undefined,
            userDisplayName: '',
            userDisplayNameDialog: false
        };

        const dis = this;

        pubSub.sub(pubSub.EVENT_REQUEST_START, (data) => {
            dis.setState({ isBusy: true });
        });
        pubSub.sub(pubSub.EVENT_REQUEST_END, (data) => {
            dis.setState({ isBusy: false });
        });
        pubSub.sub(pubSub.EVENT_REQUEST_ERROR, (error) => {

            var errorMessage = `(${error.code}) ${error.message}`;

            if (error.code === undefined) {
                errorMessage = error.message;
            }

            dis.setState({ error: errorMessage });
            console.error(`Error reported.`, error);
        });

        this.service = new BackendClient();
    }

    componentDidMount() {

        const dis = this;

        this.authStateSub = this.service.a.onAuthStateChanged(function (user) {

            if (user) {

                console.debug('User signed in.', user.uid);
                dis.setState({
                    status_auth: STATUS_AUTH_LOGGEDIN
                });
                dis.startListeningForUserDoc();
            } else {

                // Clear both auth and user state flags to reset
                console.debug("User signed out.")
                dis.setState({
                    status_auth: STATUS_AUTH_LOGGEDOUT,
                    status_user: undefined
                });
                dis.stopListeningForUserDoc();
            }
        });
    }

    componentWillUnmount() {
        
        if (this.authStateSub) {
            this.authStateSub();
            this.authStateSub = undefined;
        }

        this.stopListeningForUserDoc();
    }

    startListeningForUserDoc = () => {

        const dis = this;

        this.stopListeningForUserDoc();

        this.userDocSub = this.service.fs.doc(`users/${this.service.a.currentUser.uid}`).onSnapshot(doc => {

            if (dis.service.a.currentUser === undefined) {
                // Stop as this might have been triggered after logging out
                return;
            }

            var newState = {
                status_user: STATUS_USER_NULL
            };

            if (doc.exists) {

                newState.status_user = STATUS_USER_IDLE;

                let user = doc.data();

                newState.userDisplayName = user.displayName;

                if (user.atRoom !== undefined && user.atSeat !== undefined) {

                    newState.status_user = STATUS_USER_PLAYING;
                    newState.atRoom = user.atRoom;
                    newState.atSeat = user.atSeat;
                }
            }

            dis.setState(newState);
        });
    }

    stopListeningForUserDoc = () => {

        if (this.userDocSub) {
            this.userDocSub();
            this.userDocSub = undefined;
        }
    }

    showDisplayNameDialog = () => {

        this.setState({ userDisplayNameDialog: true });
    }

    hideDisplayNameDialog = () => {

        this.setState({ userDisplayNameDialog: false });
    }

    setDisplayName = async (value) => {

        await this.service.setUserDisplayName(this.service.a.currentUser.uid, value);
        this.hideDisplayNameDialog();
        this.fetchDisplayName(true);
    }

    fetchDisplayName = (forceFetch = false) => {

        const dis = this;

        this.service.getUserDisplayName(this.service.a.currentUser.uid, forceFetch).then(value => {

            dis.setState({ userDisplayName: value });
            if(dis.state.userDisplayName.length > 25) dis.showDisplayNameDialog()
        });
    }

    changeDisplayNameBtn = () => {
        return(
            <Button id='home-button-change-name' flat secondary iconChildren="edit" iconBefore={false}
                    onClick={this.showDisplayNameDialog}>

                {this.state.userDisplayName} 
            </Button>
        )  
    }

    logOut = () => {

        const dis = this;

        this.service.a.signOut().catch(function (error) {
            console.error('Error signing out.', error);
            dis.pubSub.pub(pubSub.EVENT_REQUEST_ERROR, error);
        });
    }
    logoutBtn = ()=>{
        return (
            <Button flat secondary 
                    onClick={this.logOut}>
                Log Out
            </Button>
        )
    }

    ackError = () => {
        this.setState({ error: undefined });
    }

    render() {

        const errorDialog = <ErrorDialog
            visible={this.state.error !== undefined}
            title='Error!'
            message={this.state.error}
            labelAck='OK'
            onAck={this.ackError}
        />;

        console.debug(`Statuses: [${this.state.status_auth}, ${this.state.status_user}]`);
        return(<Router>

            <Switch>
                <Route path={["/", "/login"]} exact render={({location})=>{
                    if(this.state.status_auth === STATUS_AUTH_LOGGEDIN){
                        return( <Redirect
                         to={{
                         pathname: "/rooms",
                         state: { from: location }
                         }} />)
                     }
                     return <Login service={this.service}/>
                }}> 
                    
                </Route>
                <Route path="/rooms" render={({ location })=>{
                    if(this.state.status_auth === STATUS_AUTH_LOGGEDOUT){
                       return( <Redirect
                        to={{
                        pathname: "/login",
                        state: { from: location }
                        }} />)
                    }
                    
                    switch (this.state.status_user) {
                    default:
                        return <CircularProgress id='progress' />;
                    case STATUS_USER_NULL:
                        return <UserSetup
                            service={this.service}/>;
                    case STATUS_USER_IDLE:
                        return (
                            <div>
                                <Header
                                    title="DOUBLE6"
                                    logOut={this.logoutBtn}
                                    isBusy={this.state.isBusy}
                                    action={this.changeDisplayNameBtn()} />

                                <div className="main-content">

                                    <Rooms
                                        service={this.service}
                                        userDisplayName={this.state.userDisplayName} />

                                    <ChangeNameDialog
                                        title='Update display name'
                                        label='Display name'
                                        value={this.state.userDisplayName}
                                        onSubmit={this.setDisplayName}
                                        onCancel={this.hideDisplayNameDialog}
                                        visible={this.state.userDisplayNameDialog} />
                                </div>
                                {errorDialog}
                            </div>
                        );
                    case STATUS_USER_PLAYING:
                        return (
                            <Redirect
                                to={{
                                pathname: `/room/${this.state.atRoom}`,
                                state: { from: location }
                                }}
                            />
                        );
                    }
                    
                } }>
                
               
                </Route>

                <Route path={`/room/`} render={({location})=>{

                    switch (this.state.status_user) {
                        default:
                            return <CircularProgress id='progress' />;
                        case STATUS_USER_NULL:
                            return <UserSetup
                                service={this.service}/>;
                        case STATUS_USER_IDLE:
                            return (
                                <Redirect
                                    to={{
                                    pathname: "/rooms",
                                    state: { from: location }
                                    }}
                                />
                            );
                        case STATUS_USER_PLAYING:
                            return (
                                <div>
                                    <Room service={this.service} room={this.state.atRoom} seat={this.state.atSeat} />
                                    {errorDialog}
                                </div>
                            )
                            
                    }

                }}/>

                <Route path={`/s/:roomId`} exact render={(props)=>{
                    return <Spectate  {...props} service={this.service}></Spectate>}} 
                    />
                    
                    
                

            </Switch>

        </Router>
        )
       /* switch (this.state.status_auth) {

            default:
                return <CircularProgress id='progress' />;
            case STATUS_AUTH_LOGGEDOUT:
                return  <Login service={this.service} />;
            case STATUS_AUTH_LOGGEDIN:
                switch (this.state.status_user) {
                    default:
                        return <CircularProgress id='progress' />;
                    case STATUS_USER_NULL:
                        return <UserSetup
                            service={this.service}/>;
                    case STATUS_USER_IDLE:
                        return (
                            <div>
                                <Header
                                    title="DOUBLE6"
                                    logOut={this.logoutBtn}
                                    isBusy={this.state.isBusy}
                                    action={this.changeDisplayNameBtn()} />

                                <div className="main-content">

                                    <Rooms
                                        service={this.service}
                                        userDisplayName={this.state.userDisplayName} />

                                    <ChangeNameDialog
                                        title='Update display name'
                                        label='Display name'
                                        value={this.state.userDisplayName}
                                        onSubmit={this.setDisplayName}
                                        onCancel={this.hideDisplayNameDialog}
                                        visible={this.state.userDisplayNameDialog} />
                                </div>
                                {errorDialog}
                            </div>
                        );
                    case STATUS_USER_PLAYING:
                        return (
                            <div>
                                <Room service={this.service} room={this.state.atRoom} seat={this.state.atSeat} />
                                {errorDialog}
                            </div>
                        );
                }
        }*/
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/Home.jsx